import {observer} from "mobx-react";
import * as React from "react";
import {createRef} from "react";
import {
  VictoryAxis,
  VictoryCandlestick,
  VictoryChart,
  VictoryLabel,
  VictoryLine,
  VictoryTheme,
  VictoryZoomContainer
} from "victory";
import {precisionRound} from "components/chart/ChartUtils";

@observer
export class LineAndCandleChart extends React.Component<{ lineAndCandleData: any }> {
  containerRef;

  constructor(props: { lineAndCandleData: any }) {
    super(props);
    this.containerRef = createRef();
  }

  /**
   * In order to create a responsive fullscreen experience for the
   * graph, need to target the container and the contained SVG when
   * the graph mounts and modify the height/width to be empty so that
   * the orientation CSS can control these, and modify the container
   * to be perfectly centered.
   */
  componentDidMount() {
    if (this.containerRef.current && this.containerRef.current.children && this.containerRef.current.children.length > 0) {
      this.containerRef.current.children[0].style.height = '';
      this.containerRef.current.children[0].style.width = '';
      this.containerRef.current.children[0].style.userSelect = 'none';
      this.containerRef.current.children[0].style.touchAction = 'none';
      this.containerRef.current.children[0].style.position = 'fixed';
      this.containerRef.current.children[0].style.top = '50%';
      this.containerRef.current.children[0].style.left = '50%';
      this.containerRef.current.children[0].style.transform = 'translate(-50%, -50%)';
      this.containerRef.current.children[0].style.pointerEvents = 'none';
      if (this.containerRef.current.children[0].children && this.containerRef.current.children[0].children.length > 0) {
        this.containerRef.current.children[0].children[0].style.height = '';
        this.containerRef.current.children[0].children[0].style.width = '';
      }
    }
  }

  render() {
    const lineAndCandleData = this.props.lineAndCandleData;
    const lineData: Array<any> = [];
    const tickValues: Array<any> = [];

    for (let i = 0; i < lineAndCandleData.data.length; i++) {
      lineData.push({
        x: i + 1,
        y: precisionRound(lineAndCandleData.data[i].avg(), 2)
      });
      tickValues.push(i + 1);
    }

    const candleData: Array<any> = [];
    for (let i = 0; i < lineAndCandleData.data.length; i++) {
      candleData.push({
        x: i + 1,
        open: lineAndCandleData.data[i].min,
        low: lineAndCandleData.data[i].min,
        close: lineAndCandleData.data[i].max,
        high: lineAndCandleData.data[i].max
      });
    }

    if (1 == candleData.length) {
      return <div className="noData"><h1>Sample size too small for a weekly average.</h1></div>
    } else {
      return (
        <div className="BarChartContainer" ref={this.containerRef}>
          <VictoryChart
            theme={VictoryTheme.material}
            domainPadding={40}
            padding={{left: 75, top: 50, right: 50, bottom: 75}}
            scale={{x: "linear", y: "linear"}}
            containerComponent={<VictoryZoomContainer allowPan={true} allowZoom={false}/>}
          >
            <VictoryAxis label={lineAndCandleData.xAxisLabel}
                         style={{axisLabel: {padding: 30}}}
                         tickValues={tickValues}
            />
            <VictoryAxis dependentAxis label={lineAndCandleData.yAxisLabel}
                         style={{axisLabel: {padding: 40}}}
                         tickFormat={(t) => precisionRound(t, 2)}
                         domain={{x: [0, 12]}}
            />
            <VictoryLine
              interpolation="linear"
              data={lineData}
              labels={(graphLabel) => graphLabel.datum.y}
              labelComponent={
                <VictoryLabel className="graphLabel" style={{
                  stroke: 'none', fill: '#F2A200', fontSize: '11px', fontFamily: 'Lato', fontWeight: 100
                }} renderInPortal/>}
            />
            <VictoryCandlestick
              candleColors={{positive: '#000', negative: '#000'}}
              data={candleData}
              style={{data: {fillOpacity: 0.05, strokeWidth: 0}}}
            />
          </VictoryChart>
        </div>
      );
    }
  }
}


